module.exports = __webpack_public_path__ + "img/elementlengths_jas.a47425c5.png";